/* ==========================================================================
   PB Luxe — theme.js
   Vanilla JS, no dependencies. Uses event delegation so markup replaced by
   the Section Rendering API keeps working without re-initialising.
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {}, cartType: 'notification' };

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || theme.moneyFormat || '£{{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }

    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function replaceSection(id, html) {
    var target = document.getElementById('shopify-section-' + id);
    if (!target) return;
    var doc = parseHTML(html);
    var fresh = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
    if (fresh) target.innerHTML = fresh.innerHTML;
  }

  function updateCartBubble(html) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !html) return;
    var doc = parseHTML(html);
    var fresh = doc.querySelector('.shopify-section') || doc.body;
    bubble.innerHTML = fresh.innerHTML;
  }

  /* ---------- header ---------- */
  function initHeader() {
    var header = $('.site-header');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    window.addEventListener('resize', function () {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    });
  }

  /* ---------- drawer / search ---------- */
  var lastFocused = null;

  function openDrawer() {
    var drawer = $('#MenuDrawer');
    var overlay = $('#DrawerOverlay');
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-active');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-active');
    document.body.classList.add('drawer-open');
    var first = drawer.querySelector('a, button');
    if (first) first.focus();
  }

  function closeDrawer() {
    var drawer = $('#MenuDrawer');
    var overlay = $('#DrawerOverlay');
    if (!drawer) return;
    drawer.classList.remove('is-active');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-active');
    document.body.classList.remove('drawer-open');
    if (lastFocused) lastFocused.focus();
  }

  function toggleSearch(force) {
    var bar = $('#SearchBar');
    if (!bar) return;
    var show = typeof force === 'boolean' ? force : bar.hidden;
    bar.hidden = !show;
    $$('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', show ? 'true' : 'false'); });
    if (show) {
      var input = bar.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  }

  /* ---------- quantity ---------- */
  function stepQuantity(btn) {
    var wrap = btn.closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var step = parseInt(input.step || '1', 10) || 1;
    var min = parseInt(input.min || '0', 10);
    var value = parseInt(input.value || '0', 10) || 0;
    value = btn.dataset.step === 'down' ? Math.max(min, value - step) : value + step;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------- product form / variants ---------- */
  function getVariants(form) {
    var id = form.dataset.productJson;
    var script = id ? document.getElementById(id) : null;
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function updateVariant(form) {
    var variants = getVariants(form);
    var selects = form.id ? $$('.variant-select[form="' + form.id + '"]') : [];
    if (!selects.length) selects = $$('.variant-select', form);
    if (!variants || !selects.length) return;
    var chosen = selects.map(function (s) { return s.value; });
    var variant = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === chosen[i]; });
    });

    var idInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('[data-add-to-cart]');
    var buttonText = button ? button.querySelector('[data-add-to-cart-text]') || button : null;
    var priceEl = document.querySelector('[data-product-price="' + form.dataset.section + '"]');

    if (!variant) {
      if (button) { button.disabled = true; if (buttonText) buttonText.textContent = theme.strings.unavailable; }
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (button) {
      if (variant.available) {
        button.disabled = false;
        if (buttonText) buttonText.textContent = theme.strings.addToCart;
      } else {
        button.disabled = true;
        if (buttonText) buttonText.textContent = theme.strings.soldOut;
      }
    }

    if (priceEl) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
               '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
      } else {
        html = '<span>' + formatMoney(variant.price) + '</span>';
      }
      priceEl.innerHTML = html;
    }

    if (variant.featured_media && variant.featured_media.id) {
      activateMedia(form.dataset.section, variant.featured_media.id);
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    var sku = document.querySelector('[data-product-sku="' + form.dataset.section + '"]');
    if (sku) { sku.textContent = variant.sku || ''; sku.hidden = !variant.sku; }
    form.dispatchEvent(new CustomEvent('variant:change', { detail: variant }));
  }

  function activateMedia(sectionId, mediaId) {
    var gallery = document.querySelector('[data-gallery="' + sectionId + '"]');
    if (!gallery) return;
    $$('.product__media-item', gallery).forEach(function (item) {
      item.classList.toggle('is-active', String(item.dataset.mediaId) === String(mediaId));
    });
    $$('.product__thumb', gallery).forEach(function (thumb) {
      var active = String(thumb.dataset.mediaId) === String(mediaId);
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  /* ---------- add to cart ---------- */
  function showNotification(item, error) {
    var note = $('#CartNotification');
    if (!note) return;
    var media = note.querySelector('[data-notification-media]');
    var title = note.querySelector('[data-notification-title]');
    var variant = note.querySelector('[data-notification-variant]');
    var err = note.querySelector('[data-notification-error]');
    var product = note.querySelector('[data-notification-product]');

    if (error) {
      if (product) product.hidden = true;
      if (err) { err.hidden = false; err.textContent = error; }
    } else {
      if (product) product.hidden = false;
      if (err) { err.hidden = true; err.textContent = ''; }
      if (title) title.textContent = item.product_title || '';
      if (variant) {
        var v = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        variant.textContent = v;
        variant.hidden = !v;
      }
      if (media) {
        if (item.image) {
          media.innerHTML = '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1') + '" alt="">';
          media.hidden = false;
        } else {
          media.innerHTML = '';
          media.hidden = true;
        }
      }
    }

    note.classList.add('is-active');
    note.setAttribute('aria-hidden', 'false');
    clearTimeout(note._timer);
    note._timer = setTimeout(hideNotification, 6000);
  }

  function hideNotification() {
    var note = $('#CartNotification');
    if (!note) return;
    note.classList.remove('is-active');
    note.setAttribute('aria-hidden', 'true');
  }

  function addToCart(form) {
    var button = form.querySelector('[data-add-to-cart]');
    var buttonText = button ? button.querySelector('[data-add-to-cart-text]') || button : null;
    var original = buttonText ? buttonText.textContent : '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    if (buttonText) buttonText.textContent = theme.strings.adding;

    var body = new FormData(form);
    body.append('sections', 'cart-icon-bubble');
    body.append('sections_url', window.location.pathname);

    fetch(theme.routes.cartAdd || '/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          showNotification(null, data.description || data.message || theme.strings.error);
          return;
        }
        if (data.sections) updateCartBubble(data.sections['cart-icon-bubble']);
        if (theme.cartType === 'page') {
          window.location.href = theme.routes.cart || '/cart';
          return;
        }
        showNotification(data);
      })
      .catch(function () { showNotification(null, theme.strings.error); })
      .finally(function () {
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
        if (buttonText) buttonText.textContent = original;
      });
  }

  /* ---------- cart page ---------- */
  function changeCart(line, quantity) {
    var wrapper = $('[data-cart]');
    if (wrapper) wrapper.classList.add('is-loading');
    var sectionId = wrapper ? wrapper.dataset.section : 'main-cart';

    fetch(theme.routes.cartChange || '/cart/change', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId + ',cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          var errEl = $('[data-cart-error]');
          if (errEl) { errEl.hidden = false; errEl.textContent = data.description || data.message || theme.strings.cartError; }
          return;
        }
        if (data.sections) {
          replaceSection(sectionId, data.sections[sectionId]);
          updateCartBubble(data.sections['cart-icon-bubble']);
        }
      })
      .catch(function () {
        var errEl = $('[data-cart-error]');
        if (errEl) { errEl.hidden = false; errEl.textContent = theme.strings.cartError; }
      })
      .finally(function () {
        var w = $('[data-cart]');
        if (w) w.classList.remove('is-loading');
      });
  }

  /* ---------- product recommendations ---------- */
  function initRecommendations() {
    $$('[data-product-recommendations]').forEach(function (el) {
      var url = el.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var fresh = doc.querySelector('[data-product-recommendations]');
          if (fresh && fresh.querySelector('.product-card')) {
            el.innerHTML = fresh.innerHTML;
            el.classList.add('is-loaded');
            initReveal();
          } else {
            var section = el.closest('.shopify-section');
            if (section) section.hidden = true;
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var items = $$('.reveal');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (i) { io.observe(i); });
  }

  /* ---------- customer addresses (country / province selects) ---------- */
  function initAddressForms() {
    $$('[data-address-country-select]').forEach(function (countrySelect) {
      var formId = countrySelect.dataset.formId;
      var provinceSelect = document.getElementById('AddressProvince_' + formId);
      var provinceWrap = document.getElementById('AddressProvinceContainer_' + formId);
      var defaultCountry = countrySelect.dataset.default;
      var defaultProvince = provinceSelect ? provinceSelect.dataset.default : '';

      if (defaultCountry) countrySelect.value = defaultCountry;

      function update() {
        var option = countrySelect.options[countrySelect.selectedIndex];
        var provinces = [];
        try { provinces = JSON.parse(option.getAttribute('data-provinces') || '[]'); } catch (e) {}
        if (!provinceSelect || !provinceWrap) return;
        provinceSelect.innerHTML = '';
        if (!provinces.length) { provinceWrap.hidden = true; return; }
        provinces.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0]; o.textContent = p[1];
          provinceSelect.appendChild(o);
        });
        provinceWrap.hidden = false;
        if (defaultProvince) provinceSelect.value = defaultProvince;
      }
      countrySelect.addEventListener('change', update);
      update();
    });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var drawerOpen = t.closest('[data-drawer-open]');
    if (drawerOpen) { e.preventDefault(); openDrawer(); return; }

    var drawerToggle = t.closest('[data-drawer-toggle]');
    if (drawerToggle) {
      e.preventDefault();
      var sub = document.getElementById(drawerToggle.getAttribute('aria-controls'));
      var open = drawerToggle.getAttribute('aria-expanded') === 'true';
      drawerToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (sub) sub.hidden = open;
      return;
    }

    var drawerClose = t.closest('[data-drawer-close]');
    if (drawerClose) { e.preventDefault(); closeDrawer(); return; }

    var searchToggle = t.closest('[data-search-toggle]');
    if (searchToggle) { e.preventDefault(); toggleSearch(); return; }

    var qtyBtn = t.closest('.qty [data-step]');
    if (qtyBtn) { e.preventDefault(); stepQuantity(qtyBtn); return; }

    var thumb = t.closest('[data-thumb]');
    if (thumb) {
      e.preventDefault();
      var gallery = thumb.closest('[data-gallery]');
      if (gallery) activateMedia(gallery.dataset.gallery, thumb.dataset.mediaId);
      return;
    }

    var noteClose = t.closest('[data-notification-close]');
    if (noteClose) { e.preventDefault(); hideNotification(); return; }

    var remove = t.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeCart(parseInt(remove.dataset.line, 10), 0); return; }

    var share = t.closest('[data-share]');
    if (share) {
      e.preventDefault();
      var url = share.dataset.shareUrl || window.location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var orig = share.textContent;
          share.textContent = share.dataset.copied || 'Link copied';
          setTimeout(function () { share.textContent = orig; }, 2000);
        });
      }
      return;
    }

    var addressToggle = t.closest('[data-toggle]');
    if (addressToggle) {
      e.preventDefault();
      var target = document.getElementById(addressToggle.getAttribute('aria-controls'));
      if (target) {
        target.hidden = !target.hidden;
        addressToggle.setAttribute('aria-expanded', target.hidden ? 'false' : 'true');
      }
      return;
    }

    var addressDelete = t.closest('[data-address-delete]');
    if (addressDelete) {
      e.preventDefault();
      if (window.confirm(addressDelete.dataset.confirm || 'Are you sure?')) {
        var f = document.createElement('form');
        f.method = 'post';
        f.action = addressDelete.dataset.target;
        f.innerHTML = '<input type="hidden" name="_method" value="delete">';
        document.body.appendChild(f);
        f.submit();
      }
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.classList.contains('variant-select')) {
      var form = t.closest('form[data-product-form]');
      if (!form && t.getAttribute('form')) form = document.getElementById(t.getAttribute('form'));
      if (form) updateVariant(form);
      return;
    }
    if (t.matches('[data-cart-quantity]')) {
      var qty = parseInt(t.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      changeCart(parseInt(t.dataset.line, 10), qty);
      return;
    }
    if (t.matches('[data-sort-by]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', t.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('form[data-ajax-cart]')) {
      e.preventDefault();
      addToCart(form);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      hideNotification();
      var bar = $('#SearchBar');
      if (bar && !bar.hidden) toggleSearch(false);
    }
  });

  var overlay = document.getElementById('DrawerOverlay');
  if (overlay) overlay.addEventListener('click', closeDrawer);


  /* ---------- slideshow ---------- */
  function initSlideshows() {
    $$('[data-slideshow]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var slides = $$('[data-slide]', el);
      if (slides.length < 2) return;
      var dots = $$('[data-dot]', el);
      var index = 0, timer = null, paused = false;
      var interval = parseInt(el.dataset.interval, 10) || 6000;
      var autoplay = el.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if ($$('picture source', el).length) el.classList.add('has-mobile-images');

      function go(n) {
        index = (n + slides.length) % slides.length;
        slides.forEach(function (sl, i) { sl.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); d.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
      }
      function start() { if (!autoplay || paused) return; stop(); timer = setInterval(function () { go(index + 1); }, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      var prev = el.querySelector('[data-prev]'), next = el.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
      if (next) next.addEventListener('click', function () { go(index + 1); start(); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); start(); }); });

      el.addEventListener('mouseenter', function () { paused = true; stop(); });
      el.addEventListener('mouseleave', function () { paused = false; start(); });
      el.addEventListener('focusin', function () { paused = true; stop(); });
      el.addEventListener('focusout', function () { paused = false; start(); });
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

      // swipe
      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); start(); }
      }, { passive: true });

      start();
    });
  }


  /* ---------- sticky buy bars (phones) ---------- */
  function initStickyBars() {
    var mq = window.matchMedia('(max-width: 749px)');

    // Product page: mirror the main Add to bag button once it scrolls away
    var bar = $('[data-product-sticky]');
    if (bar && !bar.dataset.ready) {
      bar.dataset.ready = '1';
      var form = document.getElementById(bar.dataset.form);
      var mainBtn = form ? form.querySelector('[data-add-to-cart]') : null;
      var addBtn = bar.querySelector('[data-sticky-add]');
      if (form && mainBtn && addBtn && 'IntersectionObserver' in window) {
        bar.hidden = false;
        document.body.classList.add('has-sticky-bar');
        var io = new IntersectionObserver(function (entries) {
          var e = entries[0];
          var show = mq.matches && !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
        }, { threshold: 0 });
        io.observe(mainBtn);
        addBtn.addEventListener('click', function () {
          if (mainBtn.disabled) return;
          addToCart(form);
        });
        // keep price + availability in step with the variant selects
        form.addEventListener('variant:change', function () {
          var priceEl = document.querySelector('[data-product-price="' + form.dataset.section + '"]');
          var sp = bar.querySelector('[data-sticky-price]');
          if (priceEl && sp) { var sale = priceEl.querySelector('.price__sale') || priceEl.querySelector('span'); sp.textContent = (sale || priceEl).textContent.trim(); }
          addBtn.disabled = mainBtn.disabled;
          addBtn.textContent = mainBtn.disabled ? theme.strings.soldOut : theme.strings.addToCart;
        });
      }
    }

    // Home / content pages: sticky Shop button after the first scroll
    var shop = $('[data-sticky-shop]');
    if (shop && !shop.dataset.ready) {
      shop.dataset.ready = '1';
      shop.hidden = false;
      document.body.classList.add('has-sticky-bar');
      var footer = $('.site-footer-section') || $('footer');
      var footerVisible = false;
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }, { threshold: 0 }).observe(footer);
      }
      function update() {
        shop.classList.toggle('is-visible', mq.matches && window.scrollY > 320 && !footerVisible);
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
    }
  }

  /* ---------- init ---------- */
  function init() {
    initHeader();
    initReveal();
    initSlideshows();
    initStickyBars();
    initRecommendations();
    initAddressForms();
    $$('form[data-product-form]').forEach(updateVariant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-run reveal/recommendations when sections are (re)loaded
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initSlideshows();
    initRecommendations();
    $$('form[data-product-form]').forEach(updateVariant);
  });
})();
